<template>
  <nav class="navbar navbar-expand-lg fixed-top">
    <!-- Brand -->
    <a class="navbar-brand" href="/">
      <img class="logo-svg" src="@/assets/logo_maraton_hudby_brno_datum.svg" alt="Festival Maraton hudby Brno 6-9/8 2026">
    </a>

    <!-- Toggler -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon custom-toggler"></span>
    </button>

    <!-- Links -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <div class="nav-links">
        <div class="dropdown">
          <button class="dropbtn">{{ "Navigation.program" | staticTranslation }} ▾</button>
          <div class="dropdown-content">
            <a href="/program">{{ "Navigation.lineup" | staticTranslation }}</a>
            <a href="/interprets">{{ "Navigation.interprets" | staticTranslation }}</a>
            <a href="/localities">{{ "Navigation.localities" | staticTranslation }}</a>
            <a href="https://bezulicnibusking.cz/2026-2/" target="_blank" rel="noopener noreferrer">{{ "Navigation.busking" | staticTranslation }}</a>
            <a href="/directors">{{ "Navigation.directors" | staticTranslation }}</a>
          </div>
        </div>
        <div class="dropdown">
          <router-link to="/news">
            <button class="dropbtn">{{ "Navigation.news" | staticTranslation }}</button>
          </router-link>
        </div>
        <div class="dropdown">
          <router-link to="/tickets">
            <button class="dropbtn">{{ "Navigation.tickets" | staticTranslation }}</button>
          </router-link>
        </div>
        <div class="dropdown">
          <button class="dropbtn">{{ "Navigation.about" | staticTranslation }} ▾</button>
          <div class="dropdown-content">
            <a href="/about">{{ "Navigation.aboutFestival" | staticTranslation }}</a>
            <a href="/sponsors">{{ "Navigation.sponsors" | staticTranslation }}</a>
            <a href="/archiv">{{ "Navigation.archives" | staticTranslation }}</a>
            <a href="https://www.gotobrno.cz/ochutnejte/">{{ "Navigation.tasteBrno" | staticTranslation }}</a>
          </div>
        </div>
        <div class="dropdown" v-if="tugendhatVisible">
          <router-link to="/tugendhat">
            <button class="dropbtn">{{ "Navigation.tugendhat" | staticTranslation }}</button>
          </router-link>
        </div>
        <div class="dropdown">
          <router-link to="/foodStreet">
            <button class="dropbtn">{{ "Navigation.streetFood" | staticTranslation }}</button>
          </router-link>
        </div>
        <div class="dropdown">
          <router-link to="/gallery">
            <button class="dropbtn">{{ "Navigation.gallery" | staticTranslation }}</button>
          </router-link>
        </div>
        <div class="dropdown">
          <router-link to="/media">
            <button class="dropbtn">{{ "Navigation.media" | staticTranslation }}</button>
          </router-link>
        </div>
        <div class="dropdown">
          <router-link to="/contact">
            <button class="dropbtn">{{ "Navigation.contact" | staticTranslation }}</button>
          </router-link>
        </div>
        <div class="dropdown" v-if="crewPageVisible">
          <router-link to="/brigadnici">
            <button class="dropbtn">{{ "Navigation.crew" | staticTranslation }}</button>
          </router-link>
        </div>
      </div>

      <div class="nav-social">
        <a class="socialMedia" href="https://www.facebook.com/maratonhudby/">
          <img class="animation" src="@/assets/LogoFB.png" alt="Facebook">
        </a>
        <a class="socialMedia" href="https://www.instagram.com/maraton_hudby_brno/">
          <img class="animation" src="@/assets/LogoIG.png" alt="Instagram">
        </a>
        <a class="socialMedia" href="https://www.youtube.com/channel/UCqqmZYehiR0BodY4JhdZ3dg">
          <img class="animation" src="@/assets/LogoYT.png" alt="Youtube">
        </a>
        <a class="socialMedia" onclick="return false;" v-on:click="setCs" v-bind:class="{ active: isActiveCs }">
          <img class="animation" src="@/assets/LogoCZ.png" alt="CZ">
        </a>
        <a class="socialMedia" onclick="return false;" v-on:click="setEn" v-bind:class="{ active: isActiveEn }">
          <img class="animation" src="@/assets/LogoEN.png" alt="EN">
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import axios from "@/api/axiom-instance";

export default {
  name: "navbar",
  data() {
    return {
      tugendhatVisible: false,
      crewPageVisible: false
    }
  },
  created() {
    this.loadTugendhatVisibility()
    this.loadCrewPageVisibility()
  },
  methods: {
    loadTugendhatVisibility: function () {
      axios
        .get("/tugendhat/visible")
        .then((success) => {
          this.tugendhatVisible = success.data === true
        })
        .catch(() => {
          this.tugendhatVisible = false
        })
    },
    loadCrewPageVisibility: function () {
      axios
        .get("/crew-page/visible")
        .then((success) => {
          this.crewPageVisible = success.data === true
        })
        .catch(() => {
          this.crewPageVisible = false
        })
    },
    setCs: function () {
      localStorage.setItem("lang", "cs")
      location.reload()
      this.$router.push("/")
    },
    setEn: function () {
      localStorage.setItem("lang", "en")
      location.reload()
      this.$router.push("/")
    }
  },
  computed: {
    isActiveCs: function () {
      return !(localStorage.getItem('lang') === 'en')
    },
    isActiveEn: function () {
      return (localStorage.getItem('lang') === 'en')
    }
  }
}
</script>

<style scoped>
/* ── Base ── */
nav {
  background-color: #EAEAEA;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 0.3rem 1rem;
}

/* ── Brand ── */
.navbar-brand {
  display: flex;
  align-items: center;
  padding: 0;
  margin-right: 1rem;
  flex-shrink: 0;
}

/* SVG logo + datum: viewBox 255.12 × 85.04, poměr stran ~3:1 */
.logo-svg {
  height: 90px;
  width: auto;
}

/* ── Toggler ── */
.navbar-toggler {
  background-color: #152326;
  border-color: transparent;
  margin-left: auto;
}

.custom-toggler,
.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(243,186,83, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
}

/* ── Nav links ── */
.nav-links {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropbtn {
  color: black;
  padding: 12px;
  font-size: 15px;
  border: none;
  background-color: #EAEAEA;
  font-family: "Transcript Mono";
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #EAEAEA;
  min-width: 160px;
  z-index: 100;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-family: "Transcript Mono";
}

.dropdown-content a:hover {
  background-color: #d8d8d8;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: #EAEAEA;
}

/* ── Social media ── */
.nav-social {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.socialMedia {
  padding: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.socialMedia img {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.animation:hover {
  animation-name: social;
  animation-duration: 2s;
  animation-timing-function: ease-out;
}

@keyframes social {
  0%   { transform: translateY(0px); }
  70%  { transform: translateY(-6px); }
  100% { transform: translateY(0px); }
}

/* ── Responsive ── */

/* Large desktop */
@media screen and (min-width: 1400px) {
  .dropbtn {
    padding: 14px;
    font-size: 15px;
  }
  .socialMedia img {
    width: 28px;
    height: 28px;
  }
}

/* Desktop – extra left spacing */
@media screen and (min-width: 992px) {
  nav {
    padding-left: 2rem;
  }
}

/* Medium desktop – tighter spacing */
@media screen and (min-width: 992px) and (max-width: 1299px) {
  .logo-svg {
    height: 80px;
  }
  .dropbtn {
    padding: 8px 7px;
    font-size: 13px;
  }
  .socialMedia img {
    width: 22px;
    height: 22px;
  }
}

/* Small desktop */
@media screen and (min-width: 992px) and (max-width: 1099px) {
  .dropbtn {
    padding: 6px 5px;
    font-size: 12px;
  }
}

/* Mobile / tablet – collapsed menu */
@media screen and (max-width: 991px) {
  .logo-svg {
    height: 62px;
  }

  .navbar-collapse {
    max-height: calc(100vh - 72px);
    max-height: calc(100dvh - 72px);
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior-y: contain;
    -webkit-overflow-scrolling: touch;
  }

  /* Stack links vertically */
  .nav-links {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 0.5rem 0;
  }

  .dropdown {
    display: block;
    width: 100%;
  }

  .dropbtn {
    width: 100%;
    text-align: left;
    padding: 10px 16px;
    font-size: 15px;
  }

  /* Show sub-items expanded (no hover on touch) */
  .dropdown-content {
    display: block;
    position: static;
    box-shadow: none;
    min-width: unset;
    background-color: #d8d8d8;
  }

  .dropdown-content a {
    padding: 8px 28px;
    font-size: 14px;
  }

  /* Social row on mobile */
  .nav-social {
    width: 100%;
    justify-content: flex-start;
    padding: 0.5rem 0.5rem calc(0.75rem + env(safe-area-inset-bottom));
    gap: 4px;
    flex-wrap: wrap;
  }

  .socialMedia img {
    width: 30px;
    height: 30px;
  }
}
</style>
